// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar[data-v-c354961a] {
  border-right: 1px solid #d8dbdf;
  color: var(--text-500);
  overflow: auto;
}
.sidebar .logo[data-v-c354961a] {
  align-items: center;
  display: flex;
}
.sidebar .logo-img[data-v-c354961a] {
  height: 32px;
  margin: 16px 24px;
}
.sidebar .context-switcher[data-v-c354961a] {
  color: var(--primary-text);
  display: flex;
  align-items: center;
  padding: 0 24px;
  margin-top: 24px;
}
.sidebar .nav[data-v-c354961a] {
  margin-left: 16px;
  margin-right: 24px;
}
.search[data-v-c354961a] {
  padding: 24px 24px;
}`, "",{"version":3,"sources":["webpack://./../../../../packages/client/src/core-components/sidebar/sidebar.vue"],"names":[],"mappings":"AAIA;EACE,+BAAA;EACA,sBAAA;EACA,cAAA;AAHF;AAMA;EACE,mBAAA;EACA,aAAA;AAHF;AAMA;EACE,YAAA;EACA,iBAAA;AAHF;AAOA;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAJF;AAOA;EACE,iBAAA;EACA,kBAAA;AAJF;AAOA;EACE,kBAAA;AAJF","sourcesContent":["\n@use '@wholebodyapp/design/colors/palette' as *;\n@use '@wholebodyapp/design/typography/weights' as *;\n\n.sidebar {\n  border-right: 1px solid $gray-200;\n  color: var(--text-500);\n  overflow: auto;\n}\n\n.sidebar .logo {\n  align-items: center;\n  display: flex;\n}\n\n.sidebar .logo-img {\n  height: 32px;\n  margin: 16px 24px;\n}\n\n\n.sidebar .context-switcher {\n  color: var(--primary-text);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  margin-top: 24px;\n}\n\n.sidebar .nav {\n  margin-left: 16px;\n  margin-right: 24px;\n}\n\n.search {\n  padding: 24px 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
